import React from 'react';
import PropTypes from 'prop-types';
import styles from './sign-in-modal.module.scss';
import { Modal, Button } from 'react-bootstrap';
import { useTranslation } from '@/hooks';
import { useNavigate } from 'react-router-dom';
import { LOGIN_ROUTE } from '@/constants/redirect-login';

const SignInModal = ({ onClose, show = false }) => {
  const { t } = useTranslation();
  const history = useNavigate();

  return (
    <Modal className={styles.cgSignInModal + ' modal-full-screen-mobile-signIn'} show={show} onHide={onClose} centered>
      <Modal.Header className={styles.cgSignInModal__header} closeButton></Modal.Header>
      <Modal.Body className={styles.cgSignInModal__body}>
        <p className={styles.cgSignInModal__bodyHeader}>{t('moleculeTranslations.comments.signIn.header')}</p>
        <p className={styles.cgSignInModal__description}>{t('moleculeTranslations.comments.signIn.description')}</p>
        <Button className={styles.cgSignInModal__button} onClick={() => {
          history(LOGIN_ROUTE, { state: { from: { pathname: location.pathname, search: location.search, hash: location.hash } }, replace: true });
        }}>{t('moleculeTranslations.comments.signIn.button')}</Button>
      </Modal.Body>
    </Modal>
  )
}

SignInModal.propTypes = {
  onClose: PropTypes.func,
  show: PropTypes.bool,
};

export default SignInModal;
